import Vue from 'vue'
import helpers from '../globals/helpers'

Vue.mixin({
    methods: {
        ...helpers
    }
})